import {
  Project,
  ProjectSolutionType,
  TableProject,
  ProjectSiteLocation,
} from '../../models/project';

export type ProjectsState = {
  projects: TableProject[];
  loading: boolean;
  selectedProject: string | null;
  projectForApproval: Project | null;
  error: string;
  solutions: ProjectSolutionType[];
  projectToEdit: Project | null;
  expansionProjectEditors: any[];
  siteLocation: ProjectSiteLocation;
  projectsForBulk: string[];
};

export const initialState: ProjectsState = {
  projects: [] as TableProject[],
  selectedProject: null,
  loading: false,
  projectForApproval: null,
  error: null,
  solutions: [] as ProjectSolutionType[],
  expansionProjectEditors: [],
  projectToEdit: null,
  siteLocation: null,
  projectsForBulk: [],
};
